import { render } from "./Sun.vue?vue&type=template&id=2cef7065"
import script from "./Sun.vue?vue&type=script&lang=js"
export * from "./Sun.vue?vue&type=script&lang=js"

import "./Sun.vue?vue&type=style&index=0&id=2cef7065&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__